import React, { Fragment, useState, useMemo } from "react"
import {
  useTable,
  useGlobalFilter,
  useSortBy,
  useFilters,
  useExpanded,
  usePagination,
} from "react-table"
import { Table } from "reactstrap"
import { DefaultColumnFilter } from "../../Components/filters"
import TableBody from "./TableBody"
import TableFooter from "./TableFooter"
import TableHead from "./TableHead"

const TableContainer = ({
  columns,
  data,
  onHeaderClick,
  customPageSize,
  totalCount,
  pageindex,
  widthControl,
  isMobile,
  footeraddition,
  activeReportStatus,
  tableheadShow,
  supervisorFilter,
  tableHeader,
  dateMatch,
  onClick,
  setExpandedRow,
  expandedRow,
  handleVerify,
  MultileScreen,
  toggleViewModal,
  MultileReports,
  sortdata,
  SetSortdata,
  handleApprove,
  handleReject,
}) => {
  const hiddenColumns = useMemo(() => {
    const hidden = []
    columns.forEach(el => {
      if (el?.hidden === true) {
        hidden.push(el.accessor)
      }
    })
    return hidden
  }, [columns])

  const pageCount = useMemo(
    () => Math.ceil(totalCount / customPageSize),
    [totalCount, customPageSize]
  )

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    footerGroups,
  } = useTable(
    {
      columns,
      data,
      onHeaderClick: Function,
      defaultColumn: { Filter: DefaultColumnFilter },
      initialState: {
        pageIndex: pageindex,
        pageSize: customPageSize,
        hiddenColumns: hiddenColumns,
      },
      manualPagination: true,
      manualSortBy: false,
      pageCount: pageCount,
      disableSortRemove:true
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination
  )

  const [totalHoursLoader, SettotalHoursLoader] = useState(false)

  const generateSortingIndicator = column => {
    return (
      column.sort && (
        <i
          className={column.isSortedDesc ? "bx bx-sort-down" : "bx bx-sort-up"}
        ></i>
      )
    )
  }

  const toggleRowExpansion = rowId => {
    setExpandedRow(expandedRow === rowId ? null : rowId)
  }

  // Helper function to convert time string to seconds
  const getSecondsFromTimeString = timeString => {
    let time = timeString
    if(timeString.includes("T")){
       time = timeString.split("T")[1]   
    }
    const [hours, minutes, seconds] = time.split(":").map(Number)
    return hours * 3600 + minutes * 60 + seconds
  }

  const sortingTotalHours = useMemo(() => {
    return column => {
      let sortedData
      if(column.isSortedDesc == false){
      SettotalHoursLoader(true)
      sortedData = data?.sort((a, b) => {
        const timeA = getSecondsFromTimeString(a[column.id])
        const timeB = getSecondsFromTimeString(b[column.id])
        return timeB - timeA ;
      })
      setTimeout(() => {
        SetSortdata(sortedData);
        SettotalHoursLoader(false);
      },5000)
      }
      else if (column.isSortedDesc == true) {
        SettotalHoursLoader(true)
        sortedData = data?.sort((a, b) => {
          const timeA = getSecondsFromTimeString(a[column.id])
          const timeB = getSecondsFromTimeString(b[column.id])
          return timeA - timeB ;
        })
        setTimeout(() => {
          SetSortdata(sortedData);
          SettotalHoursLoader(false);
        },5000)
      }
    }
  }, [data])

  return (
    <Fragment>
      <div className={`${onClick && "table-responsive"} react-table`}>
        <Table bordered hover {...getTableProps()}>
          <TableHead
            headerGroups={headerGroups}
            onHeaderClick={onHeaderClick}
            generateSortingIndicator={generateSortingIndicator}
            widthControl={widthControl}
            tableHeader={tableHeader}
            sortingTotalHours={sortingTotalHours}
            setExpandedRow={setExpandedRow}
          />
          {page.length > 0 && footeraddition && (
            <TableFooter isMobile={isMobile} footerGroups={footerGroups} />
          )}
          <TableBody
            page={
              page.map((data,index)=>{
                data.id=String(index);
                data.index=index;
                data.original.index = index;
                return data;
              })}
            getTableBodyProps={getTableBodyProps}
            tableheadShow={tableheadShow}
            expandedRow={expandedRow}
            headerGroups={headerGroups}
            prepareRow={prepareRow}
            toggleRowExpansion={toggleRowExpansion}
            columns={columns}
            // data={sortdata}
            data={sortdata?.length !== 0 ? sortdata : data}
            activeReportStatus={activeReportStatus}
            isMobile={isMobile}
            supervisorFilter={supervisorFilter}
            dateMatch={dateMatch}
            onClick={onClick}
            toggleViewModal={toggleViewModal}
            MultileReports={MultileReports}
            handleVerify={handleVerify}
            MultileScreen={MultileScreen}
            totalHoursLoader={totalHoursLoader}
            handleApprove={handleApprove}
            handleReject={handleReject}
          />
        </Table>
      </div>
    </Fragment>
  )
}

export default TableContainer
